export default {
  w: 512,
  p: '',
}
